import React, { useEffect, useState } from "react";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Breadcrumb from "../../../../../Components/Breadcrumb/Breadcrumb";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getGenMaster } from "../../../../../Store/Store/GenralMaster/GenMaster";
import { getProject } from "../../../../../Store/Store/Project/Project";
import { getItem } from "../../../../../Store/Store/Item/Item";
import { getTransport } from "../../../../../Store/Store/StoreMaster/Transport/Transport";
import { V_URL } from "../../../../../BaseUrl";
import toast from "react-hot-toast";
import Footer from "../../../Include/Footer";
import IssueFields from "./components/IssueFields";
import moment from "moment";
import IssueItems from "./components/IssueItems";
import { getParty } from "../../../../../Store/Store/Party/Party";
import axios from "axios";
import { getViewIssItems } from "../../../../../Store/prosafe/proTransaction/ProIssue/getViewIssItems";
import { getDepartment } from "../../../../../Store/Admin/believe/PurchaseRequest/department";
import { getLocation } from "../../../../../Store/Store/StoreMaster/InventoryLocation/Location";

const ManageIss = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const modify_by = localStorage.getItem("PAY_USER_ID");

  const { state: data } = useLocation();
  const [disable, setDisable] = useState(false);
  const [error, setError] = useState({});
  const [form, setForm] = useState({
    trans_date: moment(Date.now()).format("YYYY-MM-DD"),
    // party_id: "",
    project_id: "",
    manual_pro_no: "",
    get_pass: "",
    bill_no: "",
    receive_date: moment(Date.now()).format("YYYY-MM-DD"),
    master_id: "",
    authorised_id: "",
    taken_id: "",
    lr_no: "",
    lr_date: "",
    transport_id: "",
    vehical_no: "",
    transport_charges: "",
    address: "",
    paid_by: "",
    department_id: "",
    store_location_id: "",
    remarks: "",
    transport_date: "",
    status: "",
  });

  const [itemsArr, setItemsArr] = useState([]);

  useEffect(() => {
    dispatch(getGenMaster({}));
    dispatch(getProject());
    dispatch(getParty({ is_main: true }));
    dispatch(getItem({ is_main: true }));
    dispatch(getTransport());
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (error[name]) {
      setError((prev) => {
        const newError = { ...prev };
        delete newError[name];
        return newError;
      });
    }
  };

  useEffect(() => {
    dispatch(getDepartment());
    dispatch(getLocation());
  }, [dispatch]);

  const getDropdownDepartment = useSelector(
    (state) => state?.getDropdownDepartment?.user?.data
  );

  const locationData = useSelector((state) => state?.getLocation?.user?.data);

  const itemData = useSelector((state) => state?.getViewIssItems?.user?.data);
  useEffect(() => {
    if (data?._id) {
      dispatch(getViewIssItems({ formData: { id: data?._id } }));
      setForm({
        trans_date: data?.trans_date
          ? moment(data?.trans_date).format("YYYY-MM-DD")
          : "",
        // party_id: data?.party_data?._id,
        project_id: data?.project_data?._id || "",
        manual_pro_no: data?.manual_pro_no || "",
        get_pass: data?.get_pass || "",
        bill_no: data?.bill_no ? data?.bill_no : "",
        receive_date: data?.receive_date
          ? moment(data?.receive_date).format("YYYY-MM-DD")
          : "",
        master_id: data?.issue_by?._id || "",
        authorised_id: data?.authorisedBy?._id || "",
        taken_id: data?.takenBy?._id || "",
        lr_no: data?.lr_no || "",
        lr_date: data?.lr_date
          ? moment(data?.lr_date).format("YYYY-MM-DD")
          : "",
        transport_id: data?.transport_data?._id || "",
        vehical_no: data?.vehical_no || "",
        transport_charges: data?.transport_charges || "",
        address: data?.address || "",
        paid_by: data?.paid_by || "",
        department_id: data?.department_id || "",
        store_location_id: data?.store_location_id || "",
        remarks: data?.remarks || "",
        transport_date: data?.transport_date
          ? moment(data?.transport_date).format("YYYY-MM-DD")
          : "",
        status: data?.status,
      });
    } else {
      handleReset();
    }
  }, [data]);

  useEffect(() => {
    if (data?._id) {
      if (itemData?.items_details?.length > 0) {
        setItemsArr(itemData.items_details);
      } else {
        setItemsArr([]);
      }
    } else {
      setItemsArr([]);
    }
  }, [itemData, data]);

  const validateItems = () => {
    if (!itemsArr || itemsArr.length === 0) {
      toast.error("At least one item is required");
      return false;
    }
    return true;
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;
    const checkRequired = (field, message) => {
      if (!form[field]) {
        newErrors[field] = message;
        isValid = false;
      }
    };
    if (!form.trans_date) {
      newErrors.trans_date = "Date is required";
      isValid = false;
    } else {
      const selectedDate = new Date(form.trans_date);
      const currentDate = new Date();
      if (selectedDate > currentDate) {
        newErrors.trans_date = "Date cannot be in the future";
        isValid = false;
      }
    }
    checkRequired("project_id", "Project is required");
    checkRequired("authorised_id", "Authorised By is required");
    checkRequired("taken_id", "Taken By is required");
    // checkRequired("party_id", "Party is required");
    checkRequired("receive_date", "Receiving Date is required");
    checkRequired("master_id", "Received By is required");
    checkRequired("bill_no", "Bill No. is required");
    checkRequired("transport_id", "Transport is required");
    setError(newErrors);
    return isValid;
  };


  const handleSubmit = () => {
    if (!validateForm()) {
      return;
    }
    if (!validateItems()) {
      return;
    }

    setDisable(true);
    const myurl = `${V_URL}/prosafe/pro-add-one-iss`;

    // const formData = new URLSearchParams();
    // formData.append("firm_id", localStorage.getItem("PAY_USER_FIRM_ID"));
    // formData.append("year_id", localStorage.getItem("PAY_USER_YEAR_ID"));
    // formData.append("tag_number", 13);
    // formData.append("trans_date", form.trans_date);
    // formData.append("party_id", form.party_id);
    // formData.append("project_id", form.project_id);
    // formData.append("get_pass", form.get_pass);
    // formData.append("bill_no", form.bill_no);
    // formData.append("receive_date", form.receive_date);
    // formData.append("master_id", form.master_id);
    // formData.append("lr_no", form.lr_no);
    // formData.append("lr_date", form.lr_date);
    // formData.append("transport_id", form.transport_id);
    // formData.append("vehical_no", form.vehical_no);
    // formData.append("transport_charges", form.transport_charges);
    // formData.append("address", form.address);
    // formData.append("paid_by", form.paid_by);
    // formData.append("department_id", form.department_id);
    // formData.append("store_location_id", form.store_location_id);
    // formData.append("remarks", form.remarks);
    // formData.append("transport_date", form.transport_date);
    // formData.append("items_details", JSON.stringify(itemsArr));

    const payload = {
      firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
      year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
      tag_number: 13,
      trans_date: form.trans_date,
      // party_id: form.party_id,
      project_id: form.project_id,
      manual_pro_no: form.manual_pro_no,
      get_pass: form.get_pass,
      bill_no: form.bill_no,
      receive_date: form.receive_date,
      master_id: form.master_id,
      authorised_id: form.authorised_id,
      taken_id: form.taken_id,
      lr_no: form.lr_no,
      lr_date: form.lr_date,
      transport_id: form.transport_id,
      vehical_no: form.vehical_no,
      transport_charges: form.transport_charges,
      address: form.address,
      paid_by: form.paid_by,
      department_id: form.department_id ? form.department_id : null,
      store_location_id: form.store_location_id ? form.store_location_id : null,
      remarks: form.remarks,
      transport_date: form.transport_date,
      items_details: JSON.stringify(itemsArr),
      modified_by: modify_by,
    };

    axios({
      method: "post",
      url: myurl,
      data: payload,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
      },
    })
      .then((response) => {
        if (response.data.success === true) {
          toast.success(response?.data?.message);
          navigate("/main-store/user/issue-management");
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDisable(false);
      });
  };

  const handleUpdate = (e) => {
    if (!validateForm()) {
      return;
    }
    if (!validateItems()) {
      return;
    }
    setDisable(true);
    const myurl = `${V_URL}/prosafe/pro-update-iss`;
    // const formData = new URLSearchParams();
    // formData.append("id", data?._id);
    // formData.append("trans_date", form.trans_date)
    // formData.append("bill_no", form.bill_no)
    // formData.append("receive_date", form.receive_date)
    // formData.append("master_id", form.master_id)
    // formData.append("lr_no", form.lr_no)
    // formData.append("lr_date", form.lr_date)
    // formData.append("transport_id", form.transport_id)
    // formData.append("transport_date", form.transport_date)
    // formData.append("challan_no", form.challan_no)
    // formData.append("vehical_no", form.vehical_no)
    // formData.append("transport_charges", form.transport_charges ? form.transport_charges : null)
    // formData.append("address", form.address)
    // formData.append("paid_by", form.paid_by);

    const payload = {
      id: data?._id,
      trans_date: form.trans_date,
      manual_pro_no: form.manual_pro_no,
      bill_no: form.bill_no,
      receive_date: form.receive_date,
      master_id: form.master_id,
      authorised_id: form.authorised_id,
      taken_id: form.taken_id,
      lr_no: form.lr_no,
      lr_date: form.lr_date,
      transport_id: form.transport_id,
      transport_date: form.transport_date,
      challan_no: form.challan_no,
      vehical_no: form.vehical_no,
      transport_charges: form.transport_charges ? form.transport_charges : null,
      address: form.address,
      paid_by: form.paid_by,
      department_id: form.department_id ? form.department_id : null,
      store_location_id: form.store_location_id ? form.store_location_id : null,
      remarks: form.remarks,
      status: form.status,
      modified_by: modify_by
    };

    axios({
      method: "put",
      url: myurl,
      data: payload,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
      },
    })
      .then((response) => {
        if (response.data.success === true) {
          toast.success(response?.data?.message);
          navigate("/main-store/user/issue-management");
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDisable(false);
      });
  };

  const handleReset = () => {
    setForm({
      trans_date: moment(Date.now()).format("YYYY-MM-DD"),
      // party_id: "",
      project_id: "",
      manual_pro_no: "",
      get_pass: "",
      bill_no: "",
      receive_date: moment(Date.now()).format("YYYY-MM-DD"),
      master_id: "",
      authorised_id: "",
      taken_id: "",
      lr_no: "",
      lr_date: "",
      transport_id: "",
      vehical_no: "",
      transport_charges: "",
      address: "",
      paid_by: "",
      remarks: "",
      department_id: null,
      store_location_id: null,
      status: "",
      transport_date: "",
    });
    setItemsArr([]);
    setError({});
  };

  const breadcrumbItems = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    { label: "Issue", link: "/main-store/user/issue-management" },
    { label: data?._id ? "Edit" : "Add" + " Issue", active: true },
  ];

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <Breadcrumb items={breadcrumbItems} />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="col-12">
                      <div className="form-heading">
                        <h4>{data?._id ? "Edit" : "Add"} Issue Details</h4>
                      </div>
                    </div>

                    <IssueFields
                      handleChange={handleChange}
                      form={form}
                      departmentData={getDropdownDepartment}
                      locationData={locationData}
                      error={error}
                      data={data}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>

          <IssueItems
            itemsArr={itemsArr}
            setItemsArr={setItemsArr}
            data={data}
            form={form}
          />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-12 text-end">
                    <div className="doctor-submit text-end">
                      <button
                        type="button"
                        className="btn btn-primary submit-form me-2"
                        onClick={data?._id ? handleUpdate : handleSubmit}
                        disabled={disable && !data?._id}
                      >
                        {disable
                          ? "Processing..."
                          : data?._id
                            ? "Update"
                            : "Submit"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary cancel-form"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ManageIss;
